import Vue from "vue";

// Lista documentos de um produto
export async function listProductRequestedDocuments(productId) {
  const response = await Vue.prototype.$http.get(
    `/products/${productId}/requested_documents`
  );
  return response.data;
}

// Cria um documento e associa ao produto
export async function createProductRequestedDocument(productId, payload) {
  const response = await Vue.prototype.$http.post(
    `/products/${productId}/requested_documents`,
    payload
  );
  return response.data;
}

// Atualiza documento associado ao produto
export async function updateProductRequestedDocument(
  productId,
  documentId,
  data
) {
  const response = await Vue.prototype.$http.put(
    `/products/${productId}/requested_documents/${documentId}`,
    data
  );
  return response.data;
}
